<template>
    <div class="isomerie">
        <p>
            Gleiche Summenformel, unterschiedliche Strukturformel.<br />
            Beispiel: Butan und 2-Methyl-Propan
        </p>
    </div>
</template>

<script>
export default {
    name: 'isomerie',
};
</script>
